import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DocumentoAllegato } from '../../../models/documento-allegato';
import { DocumentVersionHistoryComponent } from './documento-version-history.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [doc_version_history_modal]',
  templateUrl: 'document-version-history-modal.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class DocumentVersionHistoryModal {
  @Output() onReturn: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('docVersionHistory') docVersionHistory: DocumentVersionHistoryComponent;
  @Input() tipoPratica: number;

  initContent(documento: DocumentoAllegato, fascicolo) {
    this.tipoPratica = fascicolo.praticaBase.tipoPratica.id;
    this.docVersionHistory.init(documento, fascicolo);
    openModal('docVersionHistory');
  }

  // CREAZIONE RAPIDA
  initContentCreazioneRapida(documento: DocumentoAllegato, fascicolo, modalName:string) {
    this.tipoPratica = fascicolo.praticaBase.tipoPratica.id;
    this.docVersionHistory.init(documento, fascicolo);
    openModal(modalName);
  }
}
